<ng-template #loadingTemplate>
  <mat-spinner [diameter]="64"></mat-spinner>
</ng-template>
<div class="content" *ngIf="!loading; else loadingTemplate">
  <div class="time">
    <span class="date1">{{ currentDate | date: "EEEE, MMMM d" }}</span>
    <span class="date2">Today</span>
  </div>
  <article class="card card0">
    <img [src]="list[0].img" />
    <div class="card-content">
      <div class="badge" [ngStyle]="{ color: list[0].color1 }">
        {{ list[0].txt0 }}
      </div>
      <div
        class="txt1"
        [ngStyle]="{ color: list[0].color2 }"
        [innerHTML]="list[0].txt1"
      ></div>
      <div
        class="txt2"
        [ngStyle]="{ color: list[0].color3 }"
        [innerHTML]="list[0].txt3"
      ></div>
      <div
        class="btn"
        (click)="openDialog(list[0])"
        [ngStyle]="{ color: list[0].fontcolor1, background: list[0].btn1 }"
      >
        {{ list[0].txt4 }}
      </div>
    </div>
  </article>
  <article style="display: flex">
    <article class="card card1">
      <img [src]="list[1].img" />
      <div class="card-content">
        <div class="badge" [ngStyle]="{ color: list[1].color1 }">
          {{ list[1].txt0 }}
        </div>
        <div
          class="txt1"
          [ngStyle]="{ color: list[1].color2 }"
          [innerHTML]="list[1].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[1].txt3"
          [ngStyle]="{ color: list[1].color3 }"
        ></div>
        <div
          class="btn"
          (click)="openDialog(list[1])"
          [ngStyle]="{ color: list[1].fontcolor1, background: list[1].btn1 }"
        >
          {{ list[1].txt4 }}
        </div>
      </div>
    </article>
    <article class="card card-list">
      <div class="top">
        <div class="left">本月热销 TOP 6</div>
        <div class="right" (click)="openRanking()">查看完整版单</div>
      </div>
      <div class="items">
        <div class="item" (click)="openRanking()">
          <span class="number" style="color: #e76020">1</span>
          <app-image [fileid]="seller?.[0]?.icon"></app-image>
          <span class="name">{{ seller?.[0]?.name }}</span>
        </div>
        <div class="item" (click)="openRanking()">
          <span class="number" style="color: #53b77e">2</span>
          <app-image [fileid]="seller?.[1]?.icon"></app-image>
          <span class="name">{{ seller?.[1]?.name }}</span>
        </div>
        <div class="item" (click)="openRanking()">
          <span class="number" style="color: #3550dd">3</span>
          <app-image [fileid]="seller?.[2]?.icon"></app-image>
          <span class="name">{{ seller?.[2]?.name }}</span>
        </div>
      </div>
    </article>
  </article>
  <article class="card card2" [ngStyle]="{ background: list[2].background }">
    <div class="card-content">
      <div class="badge" [ngStyle]="{ color: list[2].color1 }">
        {{ list[2].txt0 }}
      </div>
      <div
        class="txt1"
        [ngStyle]="{ color: list[2].color2 }"
        [innerHTML]="list[2].txt1"
      ></div>
      <div
        class="txt2"
        [innerHTML]="list[2].txt3"
        [ngStyle]="{ color: list[2].color3 }"
      ></div>
      <div
        class="btn"
        (click)="openDialog(list[2])"
        [ngStyle]="{ color: list[2].fontcolor1, background: list[2].btn1 }"
      >
        {{ list[2].txt4 }}
      </div>
    </div>
    <img [src]="list[2].img" />
  </article>
  <article style="display: flex; justify-content: space-between">
    <article class="card card3" [ngStyle]="{ background: list[3].background }">
      <div class="card-content">
        <div class="img"><img [src]="list[3].img" /></div>
        <div
          class="txt1"
          [ngStyle]="{ color: list[3].color2 }"
          [innerHTML]="list[3].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[3].txt3"
          [ngStyle]="{ color: list[3].color3 }"
        ></div>
        <div class="space"></div>
        <div
          class="btn"
          (click)="openDialog(list[3])"
          [ngStyle]="{ color: list[3].fontcolor1, background: list[3].btn1 }"
        >
          {{ list[3].txt4 }}
        </div>
      </div>
    </article>
    <article class="card card3" [ngStyle]="{ background: list[4].background }">
      <div class="card-content">
        <div class="img"><img [src]="list[4].img" /></div>
        <div
          class="txt1"
          [ngStyle]="{ color: list[4].color2 }"
          [innerHTML]="list[4].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[4].txt3"
          [ngStyle]="{ color: list[4].color3 }"
        ></div>
        <div class="space"></div>
        <div
          class="btn"
          (click)="openDialog(list[4])"
          [ngStyle]="{ color: list[4].fontcolor1, background: list[4].btn1 }"
        >
          {{ list[4].txt4 }}
        </div>
      </div>
    </article>
    <article class="card card3" [ngStyle]="{ background: list[5].background }">
      <div class="card-content">
        <div class="img"><img [src]="list[5].img" /></div>
        <div
          class="txt1"
          [ngStyle]="{ color: list[5].color2 }"
          [innerHTML]="list[5].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[5].txt3"
          [ngStyle]="{ color: list[5].color3 }"
        ></div>
        <div class="space"></div>
        <div
          class="btn"
          (click)="openDialog(list[5])"
          [ngStyle]="{ color: list[5].fontcolor1, background: list[5].btn1 }"
        >
          {{ list[5].txt4 }}
        </div>
      </div>
    </article>
  </article>
  <article class="card card6" [ngStyle]="{ background: list[6].background }">
    <div class="card-content">
      <img [src]="list[6].img" />
      <div style="display: flex; flex-direction: column; flex: 1">
        <div
          class="txt1"
          [ngStyle]="{ color: list[6].color2 }"
          [innerHTML]="list[6].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[6].txt3"
          [ngStyle]="{ color: list[6].color3 }"
        ></div>
      </div>
      <div
        class="btn"
        (click)="openDialog(list[6])"
        [ngStyle]="{ color: list[6].fontcolor1, background: list[6].btn1 }"
      >
        {{ list[6].txt4 }}
      </div>
    </div>
  </article>
  <article class="card card2" [ngStyle]="{ background: list[7].background }">
    <div class="card-content">
      <div class="badge" [ngStyle]="{ color: list[7].color1 }">
        {{ list[7].txt0 }}
      </div>
      <div
        class="txt1"
        [ngStyle]="{ color: list[7].color2 }"
        [innerHTML]="list[7].txt1"
      ></div>
      <div
        class="txt2"
        [innerHTML]="list[7].txt3"
        [ngStyle]="{ color: list[7].color3 }"
      ></div>
      <div
        class="btn"
        (click)="openDialog(list[7])"
        [ngStyle]="{ color: list[7].fontcolor1, background: list[7].btn1 }"
      >
        {{ list[7].txt4 }}
      </div>
    </div>
    <img [src]="list[7].img" />
  </article>
  <article style="display: flex">
    <article class="card card1">
      <img [src]="list[8].img" />
      <div class="card-content">
        <div class="badge" [ngStyle]="{ color: list[8].color1 }">
          {{ list[8].txt0 }}
        </div>
        <div
          class="txt1"
          [ngStyle]="{ color: list[8].color2 }"
          [innerHTML]="list[8].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[8].txt3"
          [ngStyle]="{ color: list[8].color3 }"
        ></div>
        <div
          class="btn"
          (click)="openDialog(list[8])"
          [ngStyle]="{ color: list[8].fontcolor1, background: list[8].btn1 }"
        >
          {{ list[8].txt4 }}
        </div>
      </div>
    </article>
    <article
      class="card card3"
      [ngStyle]="{ background: list[9].background }"
      style="flex: 1"
    >
      <div class="card-content">
        <div class="img"><img [src]="list[9].img" /></div>
        <div
          class="txt1"
          [ngStyle]="{ color: list[9].color2 }"
          [innerHTML]="list[9].txt1"
        ></div>
        <div
          class="txt2"
          [innerHTML]="list[9].txt3"
          [ngStyle]="{ color: list[9].color3 }"
        ></div>
        <div class="space"></div>
        <div
          class="btn"
          (click)="openDialog(list[9])"
          [ngStyle]="{ color: list[9].fontcolor1, background: list[9].btn1 }"
        >
          {{ list[9].txt4 }}
        </div>
      </div>
    </article>
  </article>
  <article class="card card2" [ngStyle]="{ background: list[10].background }">
    <div class="card-content">
      <div class="badge" [ngStyle]="{ color: list[10].color1 }">
        {{ list[10].txt0 }}
      </div>
      <div
        class="txt1"
        [ngStyle]="{ color: list[10].color2 }"
        [innerHTML]="list[10].txt1"
      ></div>
      <div
        class="txt2"
        [innerHTML]="list[10].txt3"
        [ngStyle]="{ color: list[10].color3 }"
      ></div>
      <div
        class="btn"
        (click)="openDialog(list[10])"
        [ngStyle]="{ color: list[10].fontcolor1, background: list[10].btn1 }"
      >
        {{ list[10].txt4 }}
      </div>
    </div>
    <img [src]="list[10].img" />
  </article>
</div>
<app-wish-board></app-wish-board>
